import { PbError } from '@owner/errors'

import { router } from '@/router/router'
import { generateToken } from '@/utils'

const STRIPE_CLIENT_ID = import.meta.env.VITE_STRIPE_CLIENT_ID
const SQUARE_URL = import.meta.env.VITE_SQUARE_URL
const SQUARE_CLIENT_ID = import.meta.env.VITE_SQUARE_CLIENT_ID
const CLOVER_URL = import.meta.env.VITE_CLOVER_URL
const CLOVER_CLIENT_ID = import.meta.env.VITE_CLOVER_CLIENT_ID
const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID

const STRIPE_CONNECT_URL = `https://connect.stripe.com/oauth/authorize?response_type=code&scope=read_write`
const GOOGLE_CONNECT_URL = `https://accounts.google.com/o/oauth2/v2/auth`

export default {
  clearState: ({ commit }) => {
    commit('RESET_STATE')
  },

  resetGoogle: async ({ commit }) => {
    commit('RESET_GOOGLE_STATE')
  },

  resetStripe: async ({ commit }) => {
    commit('RESET_STRIPE_STATE')
  },

  startCloverConnect: async ({ rootGetters }) => {
    const locationId = rootGetters['location/id']

    const cloverAuthorizationUrl = `${CLOVER_URL}/oauth/authorize?client_id=${CLOVER_CLIENT_ID}&state=${locationId}`

    // eslint-disable-next-line xss/no-location-href-assign
    window.location.href = cloverAuthorizationUrl
  },

  startGoogleConnect: async ({ rootGetters, commit }, returnTo) => {
    const brandId = rootGetters['brand/id']

    if (!brandId)
      throw new PbError(
        'You cannot connect Google from outside the location router'
      )

    const { href } = router.resolve({
      name: 'oauth.google',
    })

    const redirect = window.location.origin + href

    const state = await generateToken()

    commit('SET_GOOGLE_STATE', {
      brandId,
      returnTo,
      state,
    })

    const redirectURL = new URL(GOOGLE_CONNECT_URL)
    redirectURL.searchParams.set('client_id', GOOGLE_CLIENT_ID)
    redirectURL.searchParams.set('redirect_uri', redirect)
    redirectURL.searchParams.set('response_type', 'code')
    redirectURL.searchParams.set(
      'scope',
      'https://www.googleapis.com/auth/business.manage https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email'
    )
    redirectURL.searchParams.set('state', state)
    redirectURL.searchParams.set('access_type', 'offline')
    redirectURL.searchParams.set('prompt', 'consent')

    // eslint-disable-next-line xss/no-location-href-assign
    window.location.href = redirectURL.toString()
  },

  startSquareConnect: async ({ rootGetters }) => {
    const locationId = rootGetters['location/id']
    const squareAuthorizationUrl = `${SQUARE_URL}/oauth2/authorize?client_id=${SQUARE_CLIENT_ID}&scope=ORDERS_READ+ORDERS_WRITE+PAYMENTS_READ+PAYMENTS_WRITE&session=false&state=${locationId}`

    // eslint-disable-next-line xss/no-location-href-assign
    window.location.href = squareAuthorizationUrl
  },

  startStripeConnect: async ({ rootGetters, commit }) => {
    const brandId = rootGetters['core/brand/active/id']
    const locationId = rootGetters['core/location/active/id']

    if (!(brandId && locationId))
      throw new PbError(
        'You cannot connect stripe from outside the location router'
      )

    const { href } = router.resolve({
      name: 'oauth.stripe',
    })

    const redirect = window.location.origin + href

    const state = await generateToken()

    commit('SET_STRIPE_STATE', {
      brandId,
      locationId,
      state,
    })

    const stripeAuthorizationUrl = `${STRIPE_CONNECT_URL}&redirect_uri=${redirect}&client_id=${STRIPE_CLIENT_ID}&state=${state}`

    // eslint-disable-next-line xss/no-location-href-assign
    window.location.href = stripeAuthorizationUrl
  },
}
